import { CheckCircle } from 'assets/icons/CheckCircle';
import { APARTMENT_ADAPTER } from 'consts';

export const BuildingHoverCard = ({ event }) => {
  const { clientX, clientY, target } = event;
  const { wallArea = 70, usageArea = 56.1, type = 'studio' } = target.dataset;

  const isNearBottom = clientY > window.innerHeight - 300;
  const isNearRight = clientX > window.innerWidth - 300;

  const cardStyle = {
    left: isNearRight ? 'auto' : clientX + 48,
    right: isNearRight ? 36 : 'auto',
    top: isNearBottom ? 'auto' : clientY,
    bottom: isNearBottom ? 36 : 'auto',
  };

  return (
    <div className="building-hover-card" style={cardStyle}>
      <div className="image">
        <img
          src={APARTMENT_ADAPTER[type].mini}
          alt={`Layout ${APARTMENT_ADAPTER[type].label || 'Căn hộ Studio'}`}
        />
      </div>
      <div className="tooltip-body">
        <p className="title">
          {APARTMENT_ADAPTER[type].label || 'Căn hộ Studio'}
        </p>
        <ul className="list">
          <li className="list-item">
            <CheckCircle />
            <span className="text">WC</span>
            <span>{APARTMENT_ADAPTER[type].wc || 0}</span>
          </li>
          <li className="list-item">
            <CheckCircle />
            <span className="text">DT thông thuỷ</span>
            <span>{usageArea}m2</span>
          </li>
          <li className="list-item">
            <CheckCircle />
            <span className="text">DT tim tường</span>
            <span>{wallArea}m2</span>
          </li>
        </ul>
      </div>
      <button className="more-btn">Tìm hiểu thêm</button>
    </div>
  );
};
